import { SOFToolOrderInfo } from '@models/interfaces';

export const hasData = ({
  data,
  orderDate,
  orderedBy,
}: SOFToolOrderInfo): boolean =>
  !(!!data.length && !!orderedBy && orderDate !== null);
